import Joi from "joi";
import {
  ChangePasswordForm,
  ForgotForm,
  LoginForm,
  ResetPasswordForm,
  SignupForm,
} from "../../features/auth/types";
export const emailRegExp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

const loginRegExp = /^[a-zA-Z0-9]+$/;

export const getLoginSchema = () =>
  Joi.object<LoginForm>({
    username: Joi.string()
      .trim()
      .pattern(new RegExp(loginRegExp))
      .min(4)
      .max(20)
      .required()
      .messages({
        "string.empty": "login required",
        "string.pattern.base": "only latin letters and numbers",
        "string.min": "min 4 characters",
        "string.max": "max 20 characters",
      }),
    password: Joi.string().required().trim(),
  });

export const getSigninSchema = () =>
  Joi.object<SignupForm>({
    username: Joi.string()
      .trim()
      .pattern(new RegExp(loginRegExp))
      .min(4)
      .max(20)
      .required()
      .messages({
        "string.empty": "login required",
        "string.pattern.base": "only latin letters and numbers",
        "string.min": "min 4 characters",
        "string.max": "max 20 characters",
      }),
    email: Joi.string().trim().pattern(new RegExp(emailRegExp)).required(),
    password: Joi.string().required(),
    // repeatPassword: Joi.any().valid(Joi.ref("password")).required(),
  });

export const getForgotSchema = () =>
  Joi.object<ForgotForm>({
    email: Joi.string().trim().pattern(new RegExp(emailRegExp)).required(),
  });

export const getResetSchema = () =>
  Joi.object<ResetPasswordForm>({
    password: Joi.string().required().trim(),
    repeatPassword: Joi.any().valid(Joi.ref("password")).required(),
  });

export const getChangePasswordSchema = () =>
  Joi.object<ChangePasswordForm>({
    current_password: Joi.string().required().trim(),
    new_password: Joi.string().required().trim(),
    repeatPassword: Joi.string().required().valid(Joi.ref("new_password")),
  });
